import { ConfigProvider, theme } from "antd";

/**
 * As funções estáticas do antd (`message.*`, `notification.*`, `Modal.*`) são
 * chamadas fora da árvore React e por isso não enxergam o `<ConfigProvider>`
 * que cada página monta — apareciam sempre no tema claro, destoando da
 * aplicação (fundo escuro).
 *
 * `ConfigProvider.config({ holderRender })` envolve o portal dessas funções
 * num ConfigProvider próprio, aplicando o mesmo tema escuro/compacto das
 * páginas. Importado uma única vez em src/App.tsx.
 */
ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider
      theme={{ algorithm: [theme.compactAlgorithm, theme.darkAlgorithm] }}
    >
      {children}
    </ConfigProvider>
  ),
});

export {};
